import { render, staticRenderFns } from "./TasteStatistic.vue?vue&type=template&id=ddc8641a&"
import script from "./TasteStatistic.vue?vue&type=script&lang=js&"
export * from "./TasteStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports